<div>
  <table #releaseDefTable mat-table [dataSource]="dataSource" class="release-history-table">

    <ng-container matColumnDef="changedBy">
      <th mat-header-cell *matHeaderCellDef> Changed By </th>
      <td mat-cell *matCellDef="let revision"> {{revision.changedBy}} </td>
    </ng-container>

    <ng-container matColumnDef="changeType">
      <th mat-header-cell *matHeaderCellDef> Change Type </th>
      <td mat-cell *matCellDef="let revision"> {{revision.changeType}} </td>
    </ng-container>

    <ng-container matColumnDef="changedDate">
      <th mat-header-cell *matHeaderCellDef> Changed Date </th>
      <td mat-cell *matCellDef="let revision"> {{revision.changedDate}} </td>
    </ng-container>

    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef> Comment </th>
      <td mat-cell *matCellDef="let revision"> {{revision.comment}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="update(row)" onkeyup="update(row)" tabIndex="0"></tr>

  </table>
</div>